<template>
    <div style="width: 100%; height:auto;">
        <div class="head">
            <!-- 比赛图像 -->
            <div style="width:225px; height:66px;">
                <img style="cursor: pointer;" width="100%" height="100%" :src="content.image" alt="AL萌新赛" @click="ClickMeGoContestPage">
            </div>      
            <!-- 比赛的文字介绍 -->
            <div style="margin-left:20px; height:75%; width: 48%;">
                <div style="font-size:14px; color:#333333; font-size:18px; cursor: pointer;" @click="ClickMeGoContestPage">
                AL-{{content.title}}
                </div>
                <div style="font-size:14px; color:#8690A8; margin-top:4px">
                    <i class="el-icon-eleme"></i> 
                    报名时间:{{ content.startTime }} 至 {{content.closeTime}}
                    <!-- {{}}年{{}}月{{}}日 {{}}:{{}} 至 {{}}年{{}}月{{}}日 {{}}:{{}} -->
                </div>
                <div style="font-size:14px; color:#8690A8; margin-top:4px">
                    <i class="el-icon-message-solid"></i> 
                    比赛时长:{{ content.time }}<!-- {{}}年{{}}月{{}}日 {{}}:{{}} 至 {{}}年{{}}月{{}}日 {{}}:{{}} -->
                </div>
                <div style="font-size:14px; color:#8690A8; margin-top:4px">
                    <i class="el-icon-s-custom"></i> 
                    报名人数:{{content.participant}}<!-- {{}} -->
                </div>
            </div>
            <!-- 这里是参与报名按钮捏 -->
            <div>
                <!-- 这个文字是动态的 -->
                <el-button v-show="!value" style="margin-left:60px" type="success" round @click="RegisterCompete">点击报名</el-button>
                <el-button v-show="value" style="margin-left:60px" type="danger" round @click="DeleteRegister">取消报名</el-button>
            </div>
        </div>
    </div>
</template>

<script>
    import { Loading } from 'element-ui';
    import Url from '@/constant/Url';
    import $ from 'jquery'
    export default {
        name:'CanCompete',
        props:['content'],
        data() {
            return {
                isShow: false,
                value: false,
                info:{},
                options:{}
            }
        },
        mounted() {
            if (this.$store.state.me.id !== "") this.ReadRegister()
            else {
                const t = setInterval(() => {
                    if (this.$store.state.me.id !== "") {
                        this.ReadRegister()
                        clearInterval(t); // 清除定时器
                    }
                }, 100);
            }
        },
        methods: {
            ClickMeGoContestPage() {
                this.$message({
                    message: '比赛还未开始',
                    type: 'warning'
                });

                // console.log("去比赛页面咯")
                // let routeData = this.$router.resolve({
                //     path:`/contestPage/competeProblem/${this.content.id}`,
                // });
                // window.open(routeData.href, '_blank');
            },
            DeleteRegister() {
                const store = this.$store
                const vue = this

                $.ajax({
                    url: Url.dRegisterCompete,
                    type:'post',
                    headers: {
                        Authorization: "Bearer " + store.state.me.token
                    },
                    data: {
                        id: vue.info.id
                    },
                    success(resp) {
                        if (resp.error_message === 'success') {
                            vue.ReadRegister()
                            // this.$message.error('错了哦，这是一条错误消息');
                            vue.$message({
                                message: '取消报名成功',
                                type: 'error'
                            });
                        } 
                    }
                })
            },
            ReadRegister() {
                const store = this.$store
                const vue = this
                $.ajax({
                    url: Url.rRegisterCompete,
                    type:'post',
                    headers: {
                        Authorization: "Bearer " + store.state.me.token
                    },
                    data: {
                        userId: store.state.me.id,
                        competeId: vue.content.id
                    },
                    success(resp) {
                        if (resp.error_message === 'success') {
                            vue.info = JSON.parse(resp.value)
                            vue.isShow = true
                            vue.value = true // 说明报过名了
                        } else {
                            vue.isShow = true
                            vue.value = false // 说明没报名
                        }
                    }
                })
            },
            RegisterCompete() {
                if (!this.$store.state.me.is_login) {
                    this.$notify({
                    title: '通知：',
                    message: '请先登录',
                    });
                    return ;
                }
                const store = this.$store
                const vue = this

                $.ajax({
                    url: Url.cRegisterCompete,
                    type:'post',
                    headers: {
                        Authorization: "Bearer " + store.state.me.token
                    },
                    data: {
                        userName: store.state.me.name,
                        userId: store.state.me.id,
                        rating: store.state.me.rating,
                        competeId: vue.content.id
                    },
                    success(resp) {
                        if (resp.error_message === 'success') {
                            vue.ReadRegister()
                            vue.$message({
                                message: '报名成功',
                                type: 'success'
                            });
                        } 
                    }
                })
            }
        },
    }
</script>

<style scoped>
.head {
    margin-top:10px;
    background-color:white;
    width: 100%;
    height: 150px;
    /* margin-left: 2%; */
    display: flex;
    float: left;
    align-items: center;
    border: 1px solid lightgrey;
    border-left: 5px solid  #25BB9B;
}
</style>